define('views/modules/questionnaire/edit/questionnaire-edit-content',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // parents views
    'src/views/form-view',
    // views
    'views/parts/menu/menu-save-action',
    'views/modules/questionnaire/edit/questionnaire-edit-form',
    // templates
    'text!templates/modules/questionnaire/edit/questionnaire-edit-content.html'

], function(
    // Libs
    _, Backbone, Mustache, U,
    // parent views
    VForm,
    // views
    VMenuSaveAction,
    VQuestionnaireEditForm,
    // templates
    TQuestionnaireEditContent
) {

    var VQuestionnaireEditContent = VForm.extend({

        template: TQuestionnaireEditContent,

        regions: {
            root: ".questionnaire-edit-content",
            menu: ".menu-actions",
            form: ".questionnaire-edit-form",
        },

        initialize: function(opt) {
            this.options = opt || {};

            this.group = this.options.group;

            var view = this.view = {
                menu: new VMenuSaveAction({
                    context: this,
                    collection: new Backbone.Collection([
                        { id: 'show-questions', itemClass: 'show-questions', content: 'questionnaire:Show questions', callback: this.onShowQuestionsAction },
                    ]),
                    onClick: this.onActionClick,
                    onSave: this.submit,
                    saveText: 'Save',
                    tooltip: {
                        container: this.regions.root,
                    }
                }),
                form: new VQuestionnaireEditForm({
                    model: this.model,
                })
            };

            this.listenTo(this.model, { 'change': this.onModelChange });
        },

        render: function() {
            // this.setPristine();

            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.menu, zone.$menu)
                .assign(view.form, zone.$form);

            this.changeSaveButtonText()
                .toggleShowQuestionsButton();

            return this;
        },

        changeSaveButtonText: function() {
            var saveButton = this.view.menu.findItem('btn-save-action');
            saveButton.set('content', this.model.hasQuestions() ? 'Save' : 'questionnaire:Save and add questions');
            return this;
        },

        toggleShowQuestionsButton: function() {
            this.view.menu.toggleHiddenButton('.show-questions', this.model.hasQuestions());
        },

        ////////////
        // events //
        ////////////

        onActionClick: function(e) {
            e.preventDefault();
        },

        onShowQuestionsAction: function() {
            this.trigger('questionnaire:show-questions', this.model);
        },

        onModelChange: function() {
            this.view.menu.toggleSaveButton(!this.isDirty());
            this.changeSaveButtonText()
                .toggleShowQuestionsButton();
        },

        onSubmit: function() {
            if (this.model.isNew()) {
                this.model.setGroup(this.group.id);
            }
        },

        onSuccess: function() {
            if (this.modelMaster.isNew()) {
                this.trigger('questionnaire:show-questions', this.model);
            }
        },
    });

    return VQuestionnaireEditContent;

});

